import React, { FC, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.85);
    animation: ${fadeIn} 0.2s ease-out;
    cursor: pointer;
`

const Image = styled.img`
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
    border-radius: 4px;
    cursor: default;
`

interface Props {
    url: string
    onClose: () => void
}

export const Lightbox: FC<Props> = ({ url, onClose }) => {
    useEffect(() => {
        const originalOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose()
        }
        window.addEventListener('keydown', handleKeyDown)

        return () => {
            document.body.style.overflow = originalOverflow
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [onClose])

    return (
        <Overlay
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-label="Image lightbox"
        >
            <Image
                src={url}
                alt="Full resolution attachment"
                onClick={(e) => e.stopPropagation()}
            />
        </Overlay>
    )
}
